module.exports = __webpack_public_path__ + "static/meta-image-la-ventures-1bc4fe8c6e37b72f59b95229b256cbb6.png";